import { render, staticRenderFns } from "./ClonePriceModalFields.vue?vue&type=template&id=fdf4e7c6&scoped=true"
import script from "./ClonePriceModalFields.vue?vue&type=script&lang=js"
export * from "./ClonePriceModalFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf4e7c6",
  null
  
)

export default component.exports